import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["show"] = "loadingScreen/show";
    ActionTypes["hide"] = "loadingScreen/hide";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    show: createAction(ActionTypes.show, () => ({
        payload: {}
    })),
    hide: createAction(ActionTypes.hide, () => ({
        payload: {}
    }))
};
